@if (inlineSearchActive) {
  <!-- InlineSearch header (setting InlineSearch); with EnableMultiSelect it adds rows (inlineMultiActive). -->
  <div class="m2o-inline" (keydown)="inlineOnKeydown($event)">
    @if (inlineHasValue && !inlineEditing && !inlineCanEdit) {
      <!-- read-only: the o2m compact display row (tailwind.css "COMPACT DISPLAY ROW"), same as saved references elsewhere -->
      <div class="m2o-inline-readonly o2m-compact-row">
        <div class="o2m-compact-icon"></div>
        <div class="o2m-compact-content">
          <span class="o2m-compact-primary" [class.m2o-inline-link]="entityFormUrl" (click)="navigateToEntity()">{{inlineSelectedText}}</span>
        </div>
      </div>
    }
    @if (inlineHasValue && !inlineEditing && inlineCanEdit) {
      <div class="m2o-inline-value">
        <span class="m2o-inline-text" [class.m2o-inline-clickable]="inlineCanEdit" (click)="inlineStartEditing()">{{inlineSelectedText}}</span>
        @if (entityFormUrl) {
          <button type="button" class="m2o-inline-btn" [title]="inlineOpenTitle" [attr.aria-label]="inlineOpenTitle" (click)="navigateToEntity()">↗</button>
        }
        @if (inlineCanEdit) {
          <button type="button" class="m2o-inline-btn" [title]="inlineRemoveTitle" [attr.aria-label]="inlineRemoveTitle" (click)="inlineClear()">×</button>
        }
      </div>
    }
    @if (inlineCanEdit && (!inlineHasValue || inlineEditing)) {
      <div class="m2o-inline-inputwrap">
        <input type="text" class="m2o-inline-input sem-text-box" [class.m2o-inline-input-x]="inlineEmptyClear && !inlineHasValue" autocomplete="off" role="combobox"
          [attr.aria-expanded]="inlineOpen" [value]="inlineText" [placeholder]="linkWithExistingData"
          (focus)="inlineOpen || inlineStartEditing()"
          (input)="inlineOnInput($any($event.target).value)" (blur)="inlineOnBlur()" />
        @if (inlineEmptyClear && !inlineHasValue) {
          <button type="button" class="m2o-inline-btn m2o-inline-rowx" title="{{jsTranslations?.WebGalis_RemoveLink}}" (mousedown)="$event.preventDefault()" (click)="inlineClear()">×</button>
        }
      </div>
    }
    @if (inlineOpen) {
      <ul class="m2o-inline-list" role="listbox">
        @if (inlineLoading && inlineHits.length == 0) {
          <li class="m2o-inline-empty">…</li>
        }
        @if (!inlineLoading && inlineHits.length == 0) {
          <li class="m2o-inline-empty">{{jsTranslations?.WebGalis_NoResults}}</li>
        }
        @for (hit of inlineHits; track $index) {
          <li role="option" class="m2o-inline-hit" [class.m2o-inline-active]="$index == inlineActive"
            (mousedown)="$event.preventDefault()" (mouseenter)="inlineActive = $index" (click)="inlinePick(hit)">
            <div class="m2o-inline-title">{{hit.title}}@if (inlineIsAdded(hit)) {<span class="m2o-inline-added">dodano</span>}</div>
            @if (hit.subtitle) {
              <div class="m2o-inline-subtitle">{{hit.subtitle}}</div>
            }
          </li>
        }
        <li role="option" class="m2o-inline-advanced" [class.m2o-inline-active]="inlineActive == inlineHits.length"
          (mousedown)="$event.preventDefault()" (click)="inlineAdvanced()">{{advancedSearchLabel}}</li>
      </ul>
    }
    @if (inlineError) {
      <div class="m2o-inline-error">{{inlineError}}</div>
    }
  </div>
} @else {
  @if (showControls && !readOnly) {
    <div>
      @if (!dataIsLinked && showLinkDataControls(entityName)) {
        <div class="right-sub-section-holder" (click)="openDialog()">
          <div class="icon-link-data"></div>
          <p>
            {{linkWithExistingData}}
          </p>
        </div>
      }
      @if (dataIsLinked && showLinkDataControls(entityName)) {
        <div class="right-sub-section-holder dataIsLinked" (click)="navigateToEntity()">
          <div class="icon-link-data"></div>
          <p>
            {{jsTranslations.WebGalis_LinkedData}}
          </p>
        </div>
      }
      @if (dataIsLinked && showLinkDataControls(entityName)) {
        <div class="right-sub-section-holder removeData" (click)="removeLinkedData()">
          <div class="icon-link-data"></div>
          <p>
            {{jsTranslations.WebGalis_RemoveLink}}
          </p>
        </div>
      }
    </div>
  }
}
